import React, { useState, useEffect, useMemo } from 'react';
import Api from "../../../services/api";
import "../../../assets/css/app/monetization.css";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { END_DATE, getColor, getDates, START_DATE } from '../../../utility';
import moment from 'moment';
import { toast } from 'react-toastify';
import "../../../assets/css/scroll-table.css";
import { Card, Row, Col, Select, DatePicker, Button, Table, Popover, Space, Collapse, Tooltip, Drawer } from 'antd';
import { CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip as RechartsTooltip, XAxis, YAxis } from "recharts";
import dayjs from 'dayjs';
import { green, red, yellow, blue, magenta , gold, grey } from '@ant-design/colors';
import { FilterOutlined, SettingOutlined, DownloadOutlined, FullscreenOutlined, SearchOutlined } from '@ant-design/icons';
import * as XLSX from "xlsx-js-style";
import { Spin } from 'antd';
// Replaced custom LoadingComponent with Antd Spin
import FilterHeader from '../../../components/FilterHeader';
import AppliedFiltersDisplay from '../../../components/AppliedFiltersDisplay';
import { useAllApps } from '../../../hooks/useData';


function AppMonetization(){
  const navigate = useNavigate();
  const location = useLocation();
  const { allApps: apps } = useAllApps();

  const [monetizations,setMonetizations]  = useState([]);
  const [startDate,setStartDate] = useState(moment().subtract(START_DATE, 'days'));
  const [endDate,setEndDate] = useState(moment().subtract(END_DATE, 'days'));
  const [dataset,setDataset] = useState({
  	labels : [],
  	datasets : []
  });
  const [dataApps, setDataApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState([]);
  
  const [parentCountries, setParentCountries] = useState([]);
  
  const [childAdType, setChildAdType] = useState("");
  const [childCountries, setChildCountries] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  const [selectedMetrics, setSelectedMetrics] = useState("imp_dau");
  const [tableData, setTableData] = useState([]);
  const [selectCountry, setSelectCountry] = useState([]);
  const [selectedNetwork, setSelectedNetwork] = useState([]);
  const [networkOptions, setNetworkOptions] = useState([]);
  const [isLoadingNetworks, setIsLoadingNetworks] = useState(false);
  const [isLoadingChart, setIsLoadingChart] = useState(false);
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  
  const [appliedChildAdType, setAppliedChildAdType] = useState(null);
  const [appliedChildCountries, setAppliedChildCountries] = useState(null);
  const [appliedSelectedNetwork, setAppliedSelectedNetwork] = useState(null);
  const [appliedSelectedMetrics, setAppliedSelectedMetrics] = useState(null);
  const [appliedSelectedApp, setAppliedSelectedApp] = useState(null);
  const [appliedStartDate, setAppliedStartDate] = useState(null);
  const [appliedEndDate, setAppliedEndDate] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);

  
  const { code, os } = useParams();
  const isReportPageWithParams = ((location?.pathname || '').includes('monetization-report')) && !!code && !!os;
  let dates = getDates(startDate,endDate);

  
   const [chartData, setChartData] = useState([]);
   const [chartKeys, setChartKeys] = useState([]);

   
   const chartColors = [
     '#111827', '#f59e0b', '#16a34a', '#ef4444', '#2563eb', '#8b5cf6', '#06b6d4',
     '#dc2626', '#059669', '#7c3aed', '#ea580c', '#0891b2', '#be123c', '#4338ca'
   ];

   
   const renderChartLines = () => {
     return chartKeys.map((key, index) => {
       if (key === 'date') return null; 
       const color = chartColors[index % chartColors.length];
       return (
         <Line 
           key={key}
           type="monotone" 
           dataKey={key} 
           stroke={color} 
           strokeWidth={key === 'All' ? 2 : 1} 
           dot={true} 
         />
       );
     }).filter(Boolean);
   };

   
   
  const filterParams = {
    apps: selectedApp,           
    adType: childAdType,         
    metrics: selectedMetrics,    
    countries: childCountries,   
    startDate: startDate.format('YYYY-MM-DD'),  
    endDate: endDate.format('YYYY-MM-DD'),      
    code: code,                  
    os: os                       
  };

  
  
  

  useEffect(() => {
    if (!code || !os) return;
    Api.get(`api/monetization?code=${code}&os=${os}&from=${startDate.format('YYYY-MM-DD')}&to=${endDate.format('YYYY-MM-DD')}`)
    .then(result => {
      if(result.data.code == 0)
        setMonetizations(result.data.data)
      else
        toast.error("Lỗi lấy dữ liệu !!");
      });
  }, [startDate,endDate,code,os]);

  useEffect(() => {
  	let datasets = transformData(monetizations);
    setDataset({
		  labels : dates,
		  datasets: datasets,
		})
  }, [monetizations]);

  const handleChangeDate = (values) => {
    if (Array.isArray(values) && values[0] && values[1]) {
      setStartDate(moment(values[0].toDate()));
      setEndDate(moment(values[1].toDate()));
    }
  };

  useEffect(() => {
    const data = (apps || []).map(i => {
      return {
        value : `${i.code}-${i.os}`,
        label : `${i.code} - ${i.name} ${i.os}`,
        thumb: i.thumb || null,
        os: i.os || null,
      }
    })
    setDataApps(data);
  }, [apps]);

  useEffect(() => {
    if (!apps || apps.length === 0) return;
    if (!code || !os) return;
    const match = apps.find(a => String(a.code) === String(code) && String(a.os).toLowerCase() === String(os).toLowerCase());
    if (match) {
      const value = `${match.code}-${match.os}`;
      setSelectedApp([value]);
    }
  }, [apps, code, os]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await Api.get(
            `/api/app/dimension_filter?dimension=country`
        );
        if (response?.data?.data) {
          const options = Array.isArray(response.data.data)
              ? response.data.data
              : [];
          setSelectCountry(options);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const handleAppsChange = (values) => {
    setSelectedApp(values || []);
  };


  const handleChangeMetrics = (value) => {
    setSelectedMetrics(value);
     
    if (value !== 'imp_dau' && value !== 'ecpm') {
      setChildAdType("");
    }
  };

  
  const handleChangeCountriesParent = (values) => {
    const parentVals = values || [];
    setParentCountries(parentVals);
    setChildCountries(parentVals);
  };

  
  const handleChangeAdTypeChild = (value) => {
    setChildAdType(value || "");
  };

  
  const handleChangeCountriesChild = (values) => {
    const val = Array.isArray(values) ? values : [];
    if (!parentCountries || parentCountries.length === 0) {
      setChildCountries(val);
      return;
    }
    const allowed = new Set(parentCountries);
    const next = val.filter(v => allowed.has(v));
    setChildCountries(next);
  };

  const handleNetworkChange = (values) => {
    setSelectedNetwork(values || []);
  };

  const handleFilterVisibleChange = (visible) => {
    setFilterVisible(visible);
  };

  const handleClearAll = () => {
    
    setChildAdType("");
    setChildCountries([]);
    setSelectedNetwork([]);
  };

  const handleApplyFilter = () => {
     setFilterVisible(false);
     
     
    setAppliedChildAdType((selectedMetrics === 'imp_dau' || selectedMetrics === 'ecpm') ? (childAdType || "") : "");
     setAppliedChildCountries(Array.isArray(childCountries) ? childCountries : []);
     setAppliedSelectedNetwork(Array.isArray(selectedNetwork) ? selectedNetwork : []);
     setAppliedSelectedMetrics(selectedMetrics || "");
     setAppliedSelectedApp(Array.isArray(selectedApp) ? selectedApp : []);
     setAppliedStartDate(startDate);
     setAppliedEndDate(endDate);
    
    const appPairs = (selectedApp || []).map(v => {
      const [c, o] = String(v).split('-');
      return { code: c, os: o };
    });
    const appObject = appPairs.reduce((acc, cur) => {
      if (cur.code) acc[cur.code] = cur.os || '';
      return acc;
    }, {});
  };

  
  useEffect(() => {
    const fetchChart = async () => {
      try {
         setIsLoadingChart(true);
        const effectiveAdType = ((appliedSelectedMetrics === 'imp_dau' || appliedSelectedMetrics === 'ecpm') && appliedChildAdType !== null) ? appliedChildAdType : '';
        const effectiveCountries = appliedChildCountries !== null
          ? appliedChildCountries
          : (parentCountries || []);
        const effectiveNetworks = appliedSelectedNetwork !== null ? appliedSelectedNetwork : [];
        const effectiveMetrics = appliedSelectedMetrics !== null ? appliedSelectedMetrics : '';
         
        
        let appParam = null;
        if (Array.isArray(appliedSelectedApp) && appliedSelectedApp.length > 0) {
          const appPairs = appliedSelectedApp.map(v => {
            const [c, o] = String(v).split('-');
            return { code: c, os: o };
          });
          const appObject = appPairs.reduce((acc, cur) => {
            if (cur.code) acc[cur.code] = cur.os || '';
            return acc;
          }, {});
          appParam = [appObject];
        } else if (code && os) {
          const appObject = { [String(code)]: String(os) };
          appParam = [appObject];
        }
        const paramsObj = {
          from: (appliedStartDate || startDate).format('YYYY-MM-DD'),
          to: (appliedEndDate || endDate).format('YYYY-MM-DD'),
          adType: effectiveAdType,
          countries: (effectiveCountries || []).join(','),
          networks: (effectiveNetworks || []).join(','),
           metrics: effectiveMetrics, 
        };
        if (appParam) {
          paramsObj.app = JSON.stringify(appParam);
        }
        const params = new URLSearchParams(paramsObj).toString();
        const res = await Api.get(`api/monetization/report?${params}`);
         const chartArr = res?.data?.data_chart;
         if (res?.data?.code === 0 && Array.isArray(chartArr) && chartArr.length > 0) {
          
           setChartData(chartArr);
           
           const keys = Object.keys(chartArr[0]).filter(key => key !== 'date');
           setChartKeys(keys);
        } else {
           setChartData([]);
           setChartKeys([]);
        }
      } catch (e) {
        console.error(e);
         setChartData([]);
         setChartKeys([]);
       } finally {
         setIsLoadingChart(false);
      }
    };
    fetchChart();
  }, [appliedChildAdType, appliedChildCountries, appliedSelectedNetwork, appliedSelectedMetrics, appliedSelectedApp, appliedStartDate, appliedEndDate]);

  const appOptions = useMemo(() => {
    return (dataApps || []).map(opt => {
      const os = (opt.os || '').toString().toLowerCase();
      const overlaySrc = os === 'ios' ? '/bg-ios.png' : (os === 'android' ? '/bg-android.png' : null);
      return {
        value: opt.value,
        label: (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {opt.thumb ? (
              <span style={{ position: 'relative', width: 20, height: 20, display: 'inline-block' }}>
                <img
                  src={opt.thumb}
                  alt={typeof opt.label === 'string' ? opt.label : 'app'}
                  style={{ width: 20, height: 20, borderRadius: 4, objectFit: 'cover', display: 'block' }}
                />
                {overlaySrc ? (
                  <img
                    src={overlaySrc}
                    alt={os}
                    style={{ position: 'absolute', inset: 0, width: 20, height: 20, borderRadius: 4, objectFit: 'cover', pointerEvents: 'none' }}
                  />
                ) : null}
              </span>
            ) : null}
            <span>{typeof opt.label === 'string' ? opt.label : String(opt.value)}</span>
          </span>
        ),
      };
    });
  }, [dataApps]);

  const countryOptions = useMemo(() => {
    return (selectCountry || []).map((c) => ({ value: c.value ?? c, label: c.label ?? c }));
  }, [selectCountry]);
  
  const childCountryOptions = useMemo(() => {
    if (!parentCountries || parentCountries.length === 0) {
      return countryOptions || [];
    }
    const setParent = new Set(parentCountries);
    return (countryOptions || []).filter(opt => setParent.has(opt.value));
  }, [countryOptions, parentCountries]);

  const metricsOptions = [
    { value: 'imp_dau', label: 'Imp/DAU' },
    { value: 'revenue', label: 'Revenue' },
    { value: 'ecpm', label: 'eCPM' },
  ];

  const adTypeOptions = [
    { value: 'inter', label: 'Inter' },
    { value: 'reward', label: 'Reward' },
    { value: 'banner', label: 'Banner' },
    { value: 'mrec', label: 'MREC' },
    { value: 'aoa', label: 'AOA' },
    { value: 'native', label: 'Native' },
  ];

  useEffect(() => {
    const fetchNetworks = async () => {
      try {
        setIsLoadingNetworks(true);
        const res = await Api.get(`/api/filter/ad_network`);
        const raw = Array.isArray(res?.data?.data) ? res.data.data : [];
        const opts = raw.map((n) => {
          const code = String(n.code || n.network || n.ad_network || n.name || '').toLowerCase();
          const name = String(n.name || n.network || n.ad_network || code).trim();
          return {
            value: code,
            label: (
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <img
                  src={`/icon/${code}-sm.png`}
                  alt={name}
                  style={{ width: 16, height: 16, objectFit: 'contain' }}
                />
                <span>{name}</span>
              </span>
            )
          };
        });
        setNetworkOptions(opts);
      } catch (e) {
        console.error('Error fetching networks', e);
        setNetworkOptions([]);
      } finally {
        setIsLoadingNetworks(false);
      }
    };
    fetchNetworks();
  }, []);

  
  const filterContent = (
    <div style={{ width: 300 }}>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 'bold' }}>Metrics</div>
        <Select
          placeholder="Metrics (default: All)"
          options={metricsOptions}
          value={selectedMetrics || undefined}
          onChange={handleChangeMetrics}
          allowClear
          style={{ width: '100%' }}
        />
      </div>
      {(selectedMetrics === 'imp_dau' || selectedMetrics === 'ecpm') && (
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 'bold' }}>Ad Type</div>
        <Select
          placeholder="Select Ad type"
             options={adTypeOptions}
          value={childAdType || undefined}
          onChange={handleChangeAdTypeChild}
             allowClear
          style={{ width: '100%' }}
        />
      </div>
      )}
      
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 'bold' }}>Country</div>
        <Select
          mode="multiple"
          showSearch
          placeholder="Select countries"
          options={childCountryOptions}
          value={childCountries}
          onChange={handleChangeCountriesChild}
          optionFilterProp="label"
          filterOption={(input, option) => {
            const text = String(option?.label ?? option?.value ?? '').toLowerCase();
            return text.includes(String(input).toLowerCase());
          }}
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 8, fontWeight: 'bold' }}>Network</div>
        <Select
          mode="multiple"
          placeholder="Select networks"
          options={networkOptions}
          value={selectedNetwork}
          onChange={handleNetworkChange}
          style={{ width: '100%' }}
        />
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
        <Button onClick={handleClearAll}>Clear All</Button>
        <Button type="primary" onClick={handleApplyFilter}>Apply</Button>
      </div>
    </div>
  );

  const { RangePicker } = DatePicker;

  const rangePickerValue = useMemo(() => [dayjs(startDate), dayjs(endDate)], [startDate, endDate]);

  const nowrapHeader = { style: { whiteSpace: 'nowrap' } };
  const nowrapCell = { style: { whiteSpace: 'nowrap', position: 'relative', padding: '0', height: '40px' } };
  
  
  const greyHeader = { style: { whiteSpace: 'nowrap', backgroundColor: 'rgb(201 194 194)', fontWeight: 'bold', textAlign: 'center' } };
  const yellowHeader = { style: { whiteSpace: 'nowrap', backgroundColor: '#FFD966', fontWeight: 'bold', textAlign: 'center' } };
  const blueHeader = { style: { whiteSpace: 'nowrap', backgroundColor: '#6FA8DC', fontWeight: 'bold', textAlign: 'center' } };
  const greenHeader = { style: { whiteSpace: 'nowrap', backgroundColor: '#93C47D', fontWeight: 'bold', textAlign: 'center' } };
  const magentaHeader = { style: { whiteSpace: 'nowrap', backgroundColor: '#F4CCCC', fontWeight: 'bold', textAlign: 'center' } };
  const purpleHeader = { style: { whiteSpace: 'nowrap', backgroundColor: '#D9D2E9', fontWeight: 'bold', textAlign: 'center' } };
  
  const tableColumns = useMemo(() => ([
    { title: 'Date', dataIndex: 'date', key: 'date', fixed: 'left', width: 160, align: 'center', onHeaderCell: () => greyHeader, onCell: () => nowrapCell, render: (v) => renderDateCell(v) },
    { title: 'CPI', dataIndex: 'cpi', key: 'cpi', align: 'center', width: 160, onHeaderCell: () => yellowHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.cpi_change, 'cpi', r) },
    { title: 'Cost', dataIndex: 'cost', key: 'cost', align: 'center', width: 160, onHeaderCell: () => yellowHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.cost_change, 'cost', r) },
    { title: 'IAA Revenue', dataIndex: 'iaa_revenue', key: 'iaa_revenue', align: 'center', width: 160, onHeaderCell: () => blueHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.iaa_revenue_change, 'iaa_revenue', r) },
    { title: 'IAP Revenue', dataIndex: 'iap_revenue', key: 'iap_revenue', align: 'center', width: 160, onHeaderCell: () => blueHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.iap_revenue_change, 'iap_revenue', r) },
    { title: 'Total Revenue', dataIndex: 'total_revenue', key: 'total_revenue', align: 'center', width: 160, onHeaderCell: () => blueHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.total_revenue_change, 'total_revenue', r) },
    { title: 'IAP Rate', dataIndex: 'iap_rate', key: 'iap_rate', align: 'center', width: 160, onHeaderCell: () => blueHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.iap_rate_change, 'iap_rate', r) },
    { title: 'ROAS', dataIndex: 'roas', key: 'roas', align: 'center', width: 160, onHeaderCell: () => blueHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.roas_change, 'roas', r) },
    { title: 'Profit', dataIndex: 'profit', key: 'profit', align: 'center', width: 160, onHeaderCell: () => blueHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.profit_change, 'profit', r) },
    { title: 'Imp/DAU Inter', dataIndex: 'imp_dau_inter', key: 'imp_dau_inter', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.imp_dau_inter_change, 'imp_dau_inter', r) },
    { title: 'Imp/DAU Reward', dataIndex: 'imp_dau_reward', key: 'imp_dau_reward', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.imp_dau_reward_change, 'imp_dau_reward', r) },
    { title: 'Imp/DAU Banner', dataIndex: 'imp_dau_banner', key: 'imp_dau_banner', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.imp_dau_banner_change, 'imp_dau_banner', r) },
    { title: 'Imp/DAU MREC', dataIndex: 'imp_dau_mrec', key: 'imp_dau_mrec', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.imp_dau_mrec_change, 'imp_dau_mrec', r) },
    { title: 'Imp/DAU AOA', dataIndex: 'imp_dau_aoa', key: 'imp_dau_aoa', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.imp_dau_aoa_change, 'imp_dau_aoa', r) },
    { title: 'Imp/DAU Native', dataIndex: 'imp_dau_native', key: 'imp_dau_native', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.imp_dau_native_change, 'imp_dau_native', r) },
    
    { title: 'eCPM', dataIndex: 'ecpm', key: 'ecpm', align: 'center', width: 160, onHeaderCell: () => purpleHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.ecpm_change, 'ecpm', r) },
    { title: 'eCPM Inter', dataIndex: 'ecpm_inter', key: 'ecpm_inter', align: 'center', width: 160, onHeaderCell: () => purpleHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.ecpm_inter_change, 'ecpm_inter', r) },
    { title: 'eCPM Reward', dataIndex: 'ecpm_reward', key: 'ecpm_reward', align: 'center', width: 160, onHeaderCell: () => purpleHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.ecpm_reward_change, 'ecpm_reward', r) },
    { title: 'eCPM Banner', dataIndex: 'ecpm_banner', key: 'ecpm_banner', align: 'center', width: 160, onHeaderCell: () => purpleHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.ecpm_banner_change, 'ecpm_banner', r) },
    { title: 'eCPM MREC', dataIndex: 'ecpm_mrec', key: 'ecpm_mrec', align: 'center', width: 160, onHeaderCell: () => purpleHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.ecpm_mrec_change, 'ecpm_mrec', r) },
    { title: 'eCPM AOA', dataIndex: 'ecpm_aoa', key: 'ecpm_aoa', align: 'center', width: 160, onHeaderCell: () => purpleHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.ecpm_aoa_change, 'ecpm_aoa', r) },
    { title: 'eCPM Native', dataIndex: 'ecpm_native', key: 'ecpm_native', align: 'center', width: 160, onHeaderCell: () => purpleHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.ecpm_native_change, 'ecpm_native', r) },
    
    { title: 'Retention 1', dataIndex: 'retention_1', key: 'retention_1', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.retention_1_change, 'retention_1', r) },
    { title: 'Retention 3', dataIndex: 'retention_3', key: 'retention_3', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.retention_3_change, 'retention_3', r) },
    { title: 'Retention 7', dataIndex: 'retention_7', key: 'retention_7', align: 'center', width: 160, onHeaderCell: () => greenHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.retention_7_change, 'retention_7', r) },
    
    { title: 'Product Note', dataIndex: 'product_note', key: 'product_note', align: 'center', width: 160, onHeaderCell: () => magentaHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.product_note_change, 'product_note', r) },
    { title: 'UA Note', dataIndex: 'ua_note', key: 'ua_note', align: 'center', width: 160, onHeaderCell: () => magentaHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.ua_note_change, 'ua_note', r) },
    { title: 'MO Note', dataIndex: 'mo_note', key: 'mo_note', align: 'center', width: 160, onHeaderCell: () => magentaHeader, onCell: () => nowrapCell, render: (v, r) => renderTrendCell(v, r.mo_note_change, 'mo_note', r) },
  ]), [yellowHeader, blueHeader, greenHeader, magentaHeader, nowrapCell , greyHeader]);

  
  const renderTrendCell = (baseValue, changeObj, dataIndex, row) => {
    const safeValue = (baseValue === undefined || baseValue === null) ? 0 : baseValue;
    const trend = changeObj?.trend || 'same';
    let bg = '#ffffff';
    if (trend === 'same') bg = 'rgb(245 233 195)';
    if (trend === 'up') bg = 'rgb(15 194 15)';
    if (trend === 'down') bg = 'rgb(194 0 0)';
    
    const isSummaryRow = row && row.date === 'Total/Average';
    const isNoteCol = ['product_note', 'ua_note', 'mo_note'].includes(dataIndex);
    if (isSummaryRow && !isNoteCol && dataIndex !== 'date') {
      bg = '#DDEBF7'; 
    }
    const pct = Number(changeObj?.delta_pct ?? 0);
    const sign = trend === 'down' && pct !== 0 ? '-' : (pct > 0 ? '+' : '');
    
    const formatNumber = (val) => {
      const n = Number(val);
      if (!isFinite(n)) return '';
      if (n === 0) return '0';
      return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(n);
    };

    
    const moneyFields = ['cost', 'cpi', 'iaa_revenue', 'iap_revenue', 'total_revenue', 'profit', 'ecpm', 'ecpm_inter', 'ecpm_reward', 'ecpm_banner', 'ecpm_mrec', 'ecpm_aoa', 'ecpm_native', 'ecpm_aoa'];
    
    
    const percentageFields = ['iap_rate', 'roas', 'retention_1', 'retention_3', 'retention_7'];
    
    
    const textFields = ['product_note', 'ua_note', 'mo_note'];
    
    
    const otherFields = ['date', 'install_users', 'imp_dau_inter', 'imp_dau_reward', 'imp_dau_banner', 'imp_dau_mrec', 'imp_dau_aoa', 'imp_dau_native', 'timeplay'];

    let formattedValue;
    let display;

    
    if (textFields.includes(dataIndex)) {
      formattedValue = safeValue || '';
      display = formattedValue;
    } else {
      
      formattedValue = formatNumber(safeValue);
      
      
      if (moneyFields.includes(dataIndex)) {
        formattedValue = `$${formattedValue}`;
      } else if (percentageFields.includes(dataIndex)) {
        formattedValue = `${formattedValue}%`;
      }
      
      
      if (isSummaryRow && !isNoteCol && dataIndex !== 'date') {
        display = `${formattedValue}`;
      } else {
        display = `${formattedValue} (${pct === 0 ? '0' : `${sign}${formatNumber(Math.abs(pct))}`}%)`;
      }
    }

    const isTextField = textFields.includes(dataIndex);
    const hasText = isTextField && String(safeValue ?? '').trim().length > 0;

    return (
      <div className="trend-cell" style={{
        backgroundColor: isTextField ? '#ffffff' : bg,
        padding: '12px 8px',
        margin: '0',
        fontWeight: 'bold',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        minHeight: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: isTextField ? (hasText ? 'rgb(2 132 199)' : '#000') : '#000',
        fontSize: '14px'
      }}>
        {display}
      </div>
    );
  };

  
  const renderDateCell = (text) => {
    const display = text ?? '';
    return (
      <div className="date-cell" style={{
        backgroundColor: 'rgb(201, 194, 194)',
        padding: '12px 8px',
        margin: '0',
        fontWeight: 'bold',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        minHeight: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#000',
        fontSize: '14px'
      }}>
        {display}
      </div>
    );
  };

  
  const mapApiToTable = (arr) => {
    return (arr || []).map((d) => ({
      key: d.date,
      date: d.date,
      cpi: d.cpi,
      cpi_change: d.cpi_change,
      cost: d.cost,
      cost_change: d.cost_change,
      iaa_revenue: d.iaa_revenue,
      iaa_revenue_change: d.iaa_revenue_change,
      iap_revenue: d.iap_revenue,
      iap_revenue_change: d.iap_revenue_change,
      total_revenue: d.total_revenue,
      total_revenue_change: d.total_revenue_change,
      ecpm: d.ecpm,
      ecpm_change: d.ecpm_change,
      ecpm_inter: d.ecpm_inter,
      ecpm_inter_change: d.ecpm_inter_change,
      ecpm_reward: d.ecpm_reward,
      ecpm_reward_change: d.ecpm_reward_change,
      ecpm_banner: d.ecpm_banner,
      ecpm_banner_change: d.ecpm_banner_change,
      ecpm_mrec: d.ecpm_mrec,
      ecpm_mrec_change: d.ecpm_mrec_change,
      ecpm_aoa: d.ecpm_aoa,
      ecpm_aoa_change: d.ecpm_aoa_change,
      ecpm_native: d.ecpm_native,
      ecpm_native_change: d.ecpm_native_change,
      ecpm_aoa: d.ecpm_aoa,
      ecpm_aoa_change: d.ecpm_aoa_change,
      iap_rate: d.iap_rate,
      iap_rate_change: d.iap_rate_change,
      roas: d.roas,
      roas_change: d.roas_change,
      profit: d.profit,
      profit_change: d.profit_change,
      imp_dau_inter: d.imp_dau_inter,
      imp_dau_inter_change: d.imp_dau_inter_change,
      imp_dau_reward: d.imp_dau_reward,
      imp_dau_reward_change: d.imp_dau_reward_change,
      imp_dau_banner: d.imp_dau_banner,
      imp_dau_banner_change: d.imp_dau_banner_change,
      imp_dau_mrec: d.imp_dau_mrec,
      imp_dau_mrec_change: d.imp_dau_mrec_change,
      imp_dau_aoa: d.imp_dau_aoa,
      imp_dau_aoa_change: d.imp_dau_aoa_change,
      imp_dau_native: d.imp_dau_native,
      imp_dau_native_change: d.imp_dau_native_change,
      retention_1: d.retention_1,
      retention_1_change: d.retention_1_change,
      retention_3: d.retention_3,
      retention_3_change: d.retention_3_change,
      retention_7: d.retention_7,
      retention_7_change: d.retention_7_change,
      timeplay: d.timeplay,
      timeplay_change: d.timeplay_change,
      product_note: d.product_note,
      ua_note: d.ua_note,
      mo_note: d.mo_note,
    }));
  };

  
  const renderPlainNumberCell = (val) => {
    const n = Number(val ?? 0);
    const text = (n === 0)
      ? '0'
      : (Number.isFinite(n) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(n) : '0');
    return (
      <div className="trend-cell" style={{
        backgroundColor: '#ffffff',
        padding: '12px 8px',
        margin: '0',
        fontWeight: 'bold',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        minHeight: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#000',
        fontSize: '14px'
      }}>
        {text}
      </div>
    );
  };

  useEffect(() => {
     
     setAppliedChildAdType("");
    setAppliedChildCountries(Array.isArray(parentCountries) ? parentCountries : []);
    setAppliedSelectedNetwork([]);
     setAppliedSelectedMetrics("imp_dau");
    setAppliedSelectedApp(Array.isArray(selectedApp) ? selectedApp : []);
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
     
  }, []);

  function transformData(monetizations) {
    let results = monetizations.map((i,k) => {
        return i.name == 'Total' ? {
        backgroundColor: getColor(k),
        borderColor: getColor(k),
        borderWidth: 2,
        data : dates.map((i1,k1) =>  parseFloat(i.values[i1] || 0)),
        fill: false,
        label : i.name,
        type : 'line',
      } : {
        backgroundColor: getColor(k),
            data : dates.map((i1,k1) =>  parseFloat(i.values[i1] || 0)),
        label : i.name,
        line : 'bar',
        maxBarThickness: 25
        }
      });
    return results;
  }

  const handleRunReport = async () => {
    try {
       setIsLoadingTable(true);
      let appParam = null;
      if (Array.isArray(selectedApp) && selectedApp.length > 0) {
        const appPairs = selectedApp.map(v => {
          const [c, o] = String(v).split('-');
          return { code: c, os: o };
        });
        const appObject = appPairs.reduce((acc, cur) => {
          if (cur.code) acc[cur.code] = cur.os || '';
          return acc;
        }, {});
        appParam = [appObject];
      } else if (code && os) {
        const appObject = { [String(code)]: String(os) };
        appParam = [appObject];
      }
      const paramsObj = {
        from: startDate.format('YYYY-MM-DD'),
        to: endDate.format('YYYY-MM-DD'),
         adType: '',
        countries: (parentCountries || []).join(','),
      };
      if (appParam) {
        paramsObj.app = JSON.stringify(appParam);
      }
      const params = new URLSearchParams(paramsObj).toString();
      const res = await Api.get(`api/monetization/report?${params}`);
      if (res?.data?.code === 0 && Array.isArray(res.data.data)) {
        const rows = mapApiToTable(res.data.data);
        const sum = res?.data?.summary;
        if (sum && typeof sum === 'object') {
          const sumRowArr = mapApiToTable([sum]);
          if (Array.isArray(sumRowArr) && sumRowArr[0]) {
            setTableData([sumRowArr[0], ...rows]);
          } else {
            setTableData(rows);
          }
        } else {
          setTableData(rows);
        }
      } else {
        
      }
       setAppliedSelectedApp(Array.isArray(selectedApp) ? selectedApp : []);
       setAppliedStartDate(startDate);
       setAppliedEndDate(endDate);
       setAppliedChildCountries(Array.isArray(parentCountries) ? parentCountries : []);
       
    } catch (e) {
      console.error(e);
      toast.error('Lỗi tải dữ liệu bảng');
     } finally {
       setIsLoadingTable(false);
    }
  };

  
  const handleExport = () => {
    try {
      if (!tableData || tableData.length === 0) {
        toast.warning('Không có dữ liệu để export');
        return;
      }

      
      const wb = XLSX.utils.book_new();
      
      
      const rgbToHex = (input) => {
        if (!input) return undefined;
        const str = String(input).trim();
        
        if (str.startsWith('#') && str.length === 7) return str.slice(1).toUpperCase();
        if (/^[0-9a-fA-F]{6}$/.test(str)) return str.toUpperCase();
        
        const m = str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
        if (!m) return undefined;
        const r = Number(m[1]).toString(16).padStart(2, "0");
        const g = Number(m[2]).toString(16).padStart(2, "0");
        const b = Number(m[3]).toString(16).padStart(2, "0");
        return (r + g + b).toUpperCase();
      };

      
      const getActualColors = () => {
        const tableEl = document.querySelector('.ant-table');
        if (!tableEl) return { headers: {}, cells: {} };
        
        const headers = {};
        const cells = {};
        
        
        const headerCells = tableEl.querySelectorAll('thead th');
        headerCells.forEach((th, index) => {
          const style = window.getComputedStyle(th);
          const bgColor = style.backgroundColor;
          if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
            headers[index] = rgbToHex(bgColor);
          }
        });
        
        
        const dataRows = tableEl.querySelectorAll('tbody tr');
        dataRows.forEach((row, rowIndex) => {
          const rowCells = row.querySelectorAll('td');
          rowCells.forEach((td, colIndex) => {
            
            let bgColor = null;
            const tdStyle = window.getComputedStyle(td);
            const tdBgColor = tdStyle.backgroundColor;
            
            if (tdBgColor && tdBgColor !== 'rgba(0, 0, 0, 0)' && tdBgColor !== 'transparent') {
              bgColor = tdBgColor;
            } else {
              
              const trendCell = td.querySelector('.trend-cell');
              if (trendCell) {
                const trendStyle = window.getComputedStyle(trendCell);
                const trendBgColor = trendStyle.backgroundColor;
                if (trendBgColor && trendBgColor !== 'rgba(0, 0, 0, 0)' && trendBgColor !== 'transparent') {
                  bgColor = trendBgColor;
                }
              }
              if (!bgColor) {
                const childElements = td.querySelectorAll('*');
                for (let child of childElements) {
                  const childStyle = window.getComputedStyle(child);
                  const childBgColor = childStyle.backgroundColor;
                  if (childBgColor && childBgColor !== 'rgba(0, 0, 0, 0)' && childBgColor !== 'transparent') {
                    bgColor = childBgColor;
                    break;
                  }
                }
              }
            }
            
            
            if (!bgColor) {
              const styleAttr = td.getAttribute('style');
              if (styleAttr) {
                const bgMatch = styleAttr.match(/background-color:\s*([^;]+)/i);
                if (bgMatch) {
                  bgColor = bgMatch[1].trim();
                }
              }
            }
            
            
            
            
            
            if (!bgColor) {
              const dateCell = td.querySelector('.date-cell');
              if (dateCell) {
                const dateStyle = window.getComputedStyle(dateCell);
                const dateBgColor = dateStyle.backgroundColor;
                if (dateBgColor && dateBgColor !== 'rgba(0, 0, 0, 0)' && dateBgColor !== 'transparent') {
                  bgColor = dateBgColor;
                }
              }
            }
            
            
            if (!bgColor) {
              const allChildren = td.querySelectorAll('*');
              for (let child of allChildren) {
                const childStyle = window.getComputedStyle(child);
                const childBgColor = childStyle.backgroundColor;
                if (childBgColor && childBgColor !== 'rgba(0, 0, 0, 0)' && childBgColor !== 'transparent') {
                  bgColor = childBgColor;
                  break;
                }
              }
            }
            
            
            if (rowIndex === 0 && colIndex === 1) {
              console.log('First row, second column:', {
                td: td,
                bgColor: bgColor,
                value: row[tableColumns[colIndex]?.dataIndex],
                colDataIndex: tableColumns[colIndex]?.dataIndex
              });
            }
            
            if (bgColor) {
              const cellKey = `${rowIndex}-${colIndex}`;
              cells[cellKey] = rgbToHex(bgColor);
            }
          });
        });
        
        return { headers, cells };
      };

      const actualColors = getActualColors();

      
      const ws = {};
      let maxC = 0;
      
      
      const headerRow = 0;
      tableColumns.forEach((col, cIndex) => {
        const cellAddr = XLSX.utils.encode_cell({ r: headerRow, c: cIndex });
        ws[cellAddr] = { v: col.title, t: "s" };
        
        
        let headerStyle = { font: { bold: true } };
        
        
        const actualColor = actualColors.headers[cIndex];
        if (actualColor) {
          headerStyle.fill = { patternType: "solid", fgColor: { rgb: actualColor } };
        } else if (col.onHeaderCell && col.onHeaderCell().style) {
          const bgColor = col.onHeaderCell().style.backgroundColor;
          if (bgColor) {
            const hexColor = rgbToHex(bgColor);
            if (hexColor) {
              headerStyle.fill = { patternType: "solid", fgColor: { rgb: hexColor } };
            }
          }
        }
        
        ws[cellAddr].s = headerStyle;
        maxC = Math.max(maxC, cIndex);
      });

      
      tableData.forEach((row, rIndex) => {
        const dataRow = rIndex + 1;
        tableColumns.forEach((col, cIndex) => {
          if (col.dataIndex && col.dataIndex !== 'key') {
            const cellAddr = XLSX.utils.encode_cell({ r: dataRow, c: cIndex });
            const value = row[col.dataIndex];
            
            let cellValue = '';
            let cellStyle = {};
            
            if (value !== undefined && value !== null) {
              if (col.dataIndex === 'date') {
                cellValue = String(value);
              } else {
                
                let numValue = Number(value) || 0;
                let trendPct = 0;
                let trendSign = '';
                
                
                const trendKey = `${col.dataIndex}_change`;
                const trendData = row[trendKey];
                
                if (trendData && typeof trendData === 'object') {
                  
                  const pct = trendData.delta_pct || 0;
                  const trend = trendData.trend || 'same';
                  
                  trendPct = Math.abs(pct);
                  trendSign = trend === 'down' && pct !== 0 ? '-' : (pct > 0 ? '+' : '');
                  
                  
                  if (trendData.baseValue !== undefined) {
                    numValue = Number(trendData.baseValue) || 0;
                  }
                }
                
                
                const isSummaryRow = row && row.date === 'Total/Average';
                const isNoteCol = ['product_note', 'ua_note', 'mo_note'].includes(col.dataIndex);

                if (['cost', 'cpi', 'iaa_revenue', 'iap_revenue', 'total_revenue', 'profit', 'ecpm', 'ecpm_inter', 'ecpm_reward', 'ecpm_banner', 'ecpm_mrec', 'ecpm_aoa', 'ecpm_native'].includes(col.dataIndex)) {
                  
                  cellValue = isSummaryRow && !isNoteCol ? `$${numValue}` : `$${numValue} (${trendPct === 0 ? '0' : `${trendSign}${trendPct}`}%)`;
                } else if (['iap_rate', 'roas', 'retention_1', 'retention_3', 'retention_7'].includes(col.dataIndex)) {
                  cellValue = isSummaryRow && !isNoteCol ? `${numValue}%` : `${numValue}% (${trendPct === 0 ? '0' : `${trendSign}${trendPct}`}%)`;
                } else if (['product_note', 'ua_note', 'mo_note'].includes(col.dataIndex)) {
                  
                  cellValue = String(value || '');
                } else {
                  
                  cellValue = isSummaryRow && !isNoteCol ? `${numValue}` : `${numValue} (${trendPct === 0 ? '0' : `${trendSign}${trendPct}`}%)`;
                }
              }
            }
            
            
            
            const isSummaryRowExport = row && row.date === 'Total/Average';
            const isNoteColExport = ['product_note', 'ua_note', 'mo_note'].includes(col.dataIndex);
            const trendKeyExport = `${col.dataIndex}_change`;
            const trendObjExport = row[trendKeyExport];
            let bgColor = null;
            if (col.dataIndex === 'date') {
              bgColor = 'rgb(201, 194, 194)';
            } else if (isSummaryRowExport && !isNoteColExport) {
              bgColor = '#DDEBF7';
            } else if (trendObjExport && typeof trendObjExport === 'object') {
              const tr = trendObjExport.trend || 'same';
              if (tr === 'up') bgColor = 'rgb(15, 194, 15)';
              else if (tr === 'down') bgColor = 'rgb(194, 0, 0)';
              else bgColor = 'rgb(245, 233, 195)';
            } else if (isNoteColExport) {
              bgColor = '#ffffff';
            } else {
              
              bgColor = 'rgb(245, 233, 195)';
            }
            if (bgColor) {
              const hexColor = rgbToHex(bgColor);
              if (hexColor) {
                cellStyle.fill = { patternType: "solid", fgColor: { rgb: hexColor } };
              }
            }
            
            
            if (!cellStyle.fill) {
              let defaultBgColor = '#ffffff';
              
              
              if (col.dataIndex === 'date') {
                defaultBgColor = 'rgb(201, 194, 194)';
              }
              
              else if (['product_note', 'ua_note', 'mo_note'].includes(col.dataIndex)) {
                defaultBgColor = '#ffffff';
              }
              
              else if (value && typeof value === 'object' && value.trend) {
                if (value.trend === 'same') defaultBgColor = 'rgb(245, 233, 195)';
                if (value.trend === 'up') defaultBgColor = 'rgb(15, 194, 15)';
                if (value.trend === 'down') defaultBgColor = 'rgb(194, 0, 0)';
              }
              
              const hexColor = rgbToHex(defaultBgColor);
              if (hexColor) {
                cellStyle.fill = { patternType: "solid", fgColor: { rgb: hexColor } };
              }
            }
            
            
            if (['product_note', 'ua_note', 'mo_note'].includes(col.dataIndex)) {
              const hexColor = rgbToHex('#ffffff');
              if (hexColor) {
                cellStyle.fill = { patternType: "solid", fgColor: { rgb: hexColor } };
              }
            }
            
            
            if (!cellStyle.fill) {
              if (col.dataIndex === 'date') {
                const hexColor = rgbToHex('rgb(201, 194, 194)');
                if (hexColor) {
                  cellStyle.fill = { patternType: "solid", fgColor: { rgb: hexColor } };
                }
              } else if (['product_note', 'ua_note', 'mo_note'].includes(col.dataIndex)) {
                const hexColor = rgbToHex('#ffffff');
                if (hexColor) {
                  cellStyle.fill = { patternType: "solid", fgColor: { rgb: hexColor } };
                }
              } else {
                let bgColor = null;
                const trendKey = `${col.dataIndex}_change`;
                const trendData = row[trendKey];
                if (trendData && typeof trendData === 'object') {
                  const trend = trendData.trend || 'same';
                  if (trend === 'same') bgColor = 'rgb(245, 233, 195)';
                  if (trend === 'up') bgColor = 'rgb(15, 194, 15)';
                  if (trend === 'down') bgColor = 'rgb(194, 0, 0)';
                } else {
                  
                  const isSummaryRow2 = row && row.date === 'Total/Average';
                  const isNoteCol2 = ['product_note', 'ua_note', 'mo_note'].includes(col.dataIndex);
                  if (isSummaryRow2 && !isNoteCol2 && col.dataIndex !== 'date') {
                    bgColor = '#DDEBF7';
                  } else {
                    bgColor = 'rgb(245, 233, 195)';
                  }
                }
                if (bgColor) {
                  const hexColor = rgbToHex(bgColor);
                  if (hexColor) {
                    cellStyle.fill = { patternType: "solid", fgColor: { rgb: hexColor } };
                  }
                }
              }
            }
            
            ws[cellAddr] = { v: cellValue, t: "s" };
            ws[cellAddr].s = cellStyle;
            maxC = Math.max(maxC, cIndex);
          }
        });
      });

      
      ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: tableData.length, c: maxC } });
      
      
      const colWidths = tableColumns.map(col => ({ wch: 15 }));
      ws['!cols'] = colWidths;

      
      XLSX.utils.book_append_sheet(wb, ws, "Monetization Report");
      
      
      const fileName = `monetization_report_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
      XLSX.writeFile(wb, fileName);
      
      toast.success('Export thành công!');
    } catch (error) {
      console.error('Export failed:', error);
      toast.error('Lỗi khi export file');
    }
  };

  
  const handleToggleFullscreen = () => {
    const tableContainer = document.querySelector('.ant-table-container');
    if (!tableContainer) return;
    
    if (!document.fullscreenElement) {
      
      const style = document.createElement('style');
      style.id = 'fullscreen-table-style';
      style.textContent = `
        .ant-table-container:fullscreen {
          width: 100vw !important;
          height: 100vh !important;
          overflow: auto !important;
          background: white !important;
          padding: 20px !important;
          box-sizing: border-box !important;
        }
        .ant-table-container:fullscreen .ant-table-wrapper {
          width: 100% !important;
          overflow-x: auto !important;
        }
        .ant-table-container:fullscreen .ant-table {
          min-width: 3800px !important;
          width: max-content !important;
        }
        .ant-table-container:fullscreen .ant-table-content {
          overflow-x: auto !important;
        }
        .ant-table-container:fullscreen .ant-table-body {
          overflow-x: auto !important;
        }
      `;
      document.head.appendChild(style);
      
      if (tableContainer.requestFullscreen) {
        tableContainer.requestFullscreen();
      } else if (tableContainer.webkitRequestFullscreen) {
        tableContainer.webkitRequestFullscreen();
      } else if (tableContainer.msRequestFullscreen) {
        tableContainer.msRequestFullscreen();
      }
    } else {
      
      const existingStyle = document.getElementById('fullscreen-table-style');
      if (existingStyle) {
        existingStyle.remove();
      }
      
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };
  
  useEffect(() => {
    handleRunReport();
    
  }, []);

  
  

  return (
    <>
    <div className='background-second-dashboard'>
      <section className="main__content-dashbard">
        <div className="container-fluid">
          <Card bodyStyle={{ padding: 20 }}>
            <div className="overview_content pd-20">
              {/* Mobile: floating toggle to open filter drawer */}
              <div className="mobile-search-toggle" style={{ 
                display: 'none',
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                zIndex: 1000
              }}>
                <Button
                  type="primary"
                  shape="circle"
                  icon={<SearchOutlined />}
                  onClick={() => setDrawerOpen(true)}
                  style={{
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    position: 'relative'
                  }}
                />
              </div>

              <div className="mb-10 hd-filter desktop-filter">
                <Row gutter={[12, 12]}>
                  {!isReportPageWithParams && (
                  <Col xs={24} sm={12} md={8} lg={6} xl={6} xxl={6}>
                    <div style={{ marginBottom: 4 }}>Apps:</div>
                    <Select
                      mode="multiple"
                      allowClear
                      placeholder="Select apps (default: All apps)"
                      options={appOptions}
                      value={selectedApp}
                      onChange={handleAppsChange}
                      style={{ width: '100%' }}
                    />
                  </Col>
                  )}
                  <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={4}>
                    <div style={{ marginBottom: 4 }}>Country:</div>
                    <Select
                      mode="multiple"
                      showSearch
                      allowClear
                      placeholder="Select country"
                      options={countryOptions}
                      value={parentCountries}
                      onChange={handleChangeCountriesParent}
                      optionFilterProp="label"
                      filterOption={(input, option) => {
                        const text = String(option?.label ?? option?.value ?? '').toLowerCase();
                        return text.includes(String(input).toLowerCase());
                      }}
                      maxTagCount={1}
                      maxTagPlaceholder="..."
                      style={{ width: '100%' }}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={8} lg={6} xl={4} xxl={4}>
                    <div style={{ marginBottom: 4 }}>Date range:</div>
                    <RangePicker
                      value={rangePickerValue}
                      onChange={handleChangeDate}
                      style={{ width: '100%' }}
                      allowClear={false}
                    />
                  </Col>
                  <Col xs={24} sm={12} md={4} lg={4} xl={2} xxl={2}>
                    <div style={{ marginBottom: 4 }}>&nbsp;</div>
                    <Button type="primary" block onClick={handleRunReport}>Run Report</Button>
                  </Col>
                </Row>
              </div>

              <Card 
                title={
                  <div className='hd-filter-chart' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px', flex: 1, minWidth: 0 }}>
                      {/* <span style={{ fontSize: '16px', fontWeight: 'bold', marginRight: '16px', whiteSpace: 'nowrap' }}>Chart Analysis</span> */}
                      <AppliedFiltersDisplay 
                        appliedValues={{
                          metrics: appliedSelectedMetrics,
                          adType: appliedChildAdType,
                          countries: appliedChildCountries,
                          networks: appliedSelectedNetwork
                        }}
                        metricsOptions={metricsOptions}
                        adTypeOptions={adTypeOptions}
                        childCountryOptions={childCountryOptions}
                        networkOptions={networkOptions}
                      />
                    </div>
                    <Space style={{ flexShrink: 0 }}>
                      <Popover
                        content={filterContent}
                        trigger="click"
                        open={filterVisible}
                        onOpenChange={handleFilterVisibleChange}
                        placement="bottomRight"
                      >
                        <Button icon={<FilterOutlined />} size="small">Filter</Button>
                      </Popover>
                    </Space>
                  </div>
                }
                style={{ marginBottom: 20 }}
              >
                <div style={{ position: 'relative' }}>
                <Spin spinning={isLoadingChart} style={{ width: '100%' }}>
                <ResponsiveContainer width="100%" height={400}>
                  <ComposedChart data={chartData} margin={{ top: 20, right: isMobile ? 20 : 150, bottom: isMobile ? 60 : 20, left: 20 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <RechartsTooltip />
                    <Legend 
                      layout={isMobile ? "horizontal" : "vertical"} 
                      align={isMobile ? "center" : "right"} 
                      verticalAlign={isMobile ? "bottom" : "middle"}
                      wrapperStyle={{ paddingLeft: isMobile ? 0 : 20 }}
                    />
                    {renderChartLines()}
                  </ComposedChart>
                </ResponsiveContainer>
                </Spin>
                </div>
              </Card>

              <div className="mb-4" style={{ position: 'relative' }}>
                <div className="d-flex justify-content-end mb-2">
                  <div className="me-2">
                    <Tooltip title="Export Excel">
                      <Button 
                        type="dashed" 
                        icon={<DownloadOutlined />} 
                        onClick={handleExport}
                        disabled={!tableData || tableData.length === 0}
                      />
                    </Tooltip>
                  </div>
                  <div>
                    <Tooltip title="Full Screen">
                      <Button 
                        type="dashed" 
                        icon={<FullscreenOutlined />} 
                        onClick={handleToggleFullscreen}
                      />
                    </Tooltip>
                  </div>
                </div>
                <Spin spinning={isLoadingTable}>
                <Table
                  columns={tableColumns}
                  dataSource={tableData}
                  pagination={false}
                  bordered
                  scroll={{ x: 3800 }}
                />
                </Spin>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </div>
    {/* Mobile: Drawer with filters */}
    <Drawer
      title="Search Filters"
      placement="right"
      onClose={() => setDrawerOpen(false)}
      open={drawerOpen}
      width={320}
      className="mobile-filter-drawer"
      zIndex={2500}
    >
      <div className="mb-10">
        <Row gutter={[12, 12]}>
          {!isReportPageWithParams && (
          <Col xs={24}>
            <div style={{ marginBottom: 4 }}>Apps:</div>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select apps (default: All apps)"
              options={appOptions}
              value={selectedApp}
              onChange={handleAppsChange}
              style={{ width: '100%' }}
            />
          </Col>
          )}
          <Col xs={24}>
            <div style={{ marginBottom: 4 }}>Country:</div>
            <Select
              mode="multiple"
              showSearch
              allowClear
              placeholder="Select country"
              options={countryOptions}
              value={parentCountries}
              onChange={handleChangeCountriesParent}
              optionFilterProp="label"
              filterOption={(input, option) => {
                const text = String(option?.label ?? option?.value ?? '').toLowerCase();
                return text.includes(String(input).toLowerCase());
              }}
              maxTagCount={1}
              maxTagPlaceholder="..."
              style={{ width: '100%' }}
            />
          </Col>
          <Col xs={24}>
            <div style={{ marginBottom: 4 }}>Date range:</div>
            <RangePicker
              value={rangePickerValue}
              onChange={handleChangeDate}
              style={{ width: '100%' }}
              allowClear={false}
              getPopupContainer={(trigger) => trigger.parentNode}
              dropdownClassName="drawer-date-dropdown"
            />
          </Col>
          <Col xs={24}>
            <div style={{ marginBottom: 4 }}>&nbsp;</div>
            <Button type="primary" block onClick={() => { handleRunReport(); setDrawerOpen(false); }}>Run Report</Button>
          </Col>
        </Row>
      </div>
    </Drawer>
    <style>{`
      @media (max-width: 768px) {
        .desktop-filter { display: none !important; }
        .mobile-search-toggle { display: block !important; }
        .mobile-filter-drawer .ant-drawer-body { padding: 10px !important; }
        .mobile-filter-drawer .drawer-date-dropdown { max-width: 100% !important; }
        .mobile-filter-drawer .drawer-date-dropdown .ant-picker-panels { flex-direction: column !important; }
      }
      @media (min-width: 769px) {
        .mobile-search-toggle { display: none !important; }
        .desktop-filter { display: block !important; }
      }
    `}</style>
    </>
  );
}
export default AppMonetization;